import { useAutoMinimizeSidebar } from "CustomHooks/useAutoMinimizeSidebar";
import React from "react";
import QuotationForm from "./Form/QuotationForm/QuotationForm";

const QuotationEditForm: React.FC = () => {
  // Auto-minimize sidebar on tablet screens
  useAutoMinimizeSidebar();

  return <QuotationForm />;
};

export default QuotationEditForm;
